import * as React from 'react';
export const firstbankSvg = React.forwardRef(function firstbankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E6771E',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M6.05 23.35V14.7H2.6v-2.6c2.31 0 4.33-1.79 4.33-3.45h4.32c-1.73 1.66-1.73 2.66-1.73 4.32 0 1.67-.28 4.08 6.92 5.2 0 0 1.73.18 1.73 1.29 0 1.1-1.73 1.3-2.6 1.3-.86 0-2.59-1.21-2.59-2.6H9.51v.87c0 1.94.87 3.21 3.46 4.32H6.05zm13.84 0s2.6-.72 2.6-4.32c0-2.87-5.2-5.2-6.92-5.2-1.5 0-1.73-.86-1.73-1.58 0-.71.54-1 1.73-1s2.05 1.6 1.73 2.59h4.32c0-.83-.65-3.25-2.6-5.2h10.39v3.47h-3.46v11.24h-6.06z',
      }),
    ),
  );
});
firstbankSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var firstbank = {
  category: 'brand',
  colorable: false,
  name: 'firstbank',
  svg: firstbankSvg,
};
